/* KIRIBAN hero collectible: turn the example piece by dragging (mouse or finger), with momentum and a slow idle spin;
   view buttons glide to front / side / back / top. Faces turned away from the light are shaded. Story strips open on
   click, tap, hover (mouse) or arrow keys. Runs only while the section is on screen. */
(function () {
  "use strict";
  var root = document.querySelector("[data-kbh]");
  if (!root) return;
  var reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- story strips ---------- */
  var strips = [].slice.call(root.querySelectorAll(".kbh-strip")), si = 0;
  function openStrip(i) {
    si = (i + strips.length) % strips.length;
    strips.forEach(function (s, j) { s.classList.toggle("on", j === si); s.setAttribute("aria-expanded", j === si ? "true" : "false"); });
  }
  var fine = matchMedia("(hover: hover) and (pointer: fine)");
  strips.forEach(function (s, i) {
    s.addEventListener("click", function () { openStrip(i); });
    s.addEventListener("mouseenter", function () { if (fine.matches) openStrip(i); });
    s.addEventListener("keydown", function (e) {
      if (e.key === "ArrowRight" || e.key === "ArrowDown") { e.preventDefault(); openStrip(si + 1); strips[si].focus(); }
      if (e.key === "ArrowLeft" || e.key === "ArrowUp") { e.preventDefault(); openStrip(si - 1); strips[si].focus(); }
    });
  });

  /* ---------- 3D object ---------- */
  var stage = root.querySelector("[data-kbh-stage]"), obj = root.querySelector("[data-kbh-obj]");
  if (!stage || !obj) return;
  var faces = { fr: 0, rt: 90, bk: 180, lt: -90 }, shadeEls = {};
  for (var k in faces) shadeEls[k] = [obj.querySelector(".kbh-" + k), obj.querySelector(".kbh-b" + k)];
  var btns = [].slice.call(root.querySelectorAll("[data-view]"));
  var S = { ry: -28, rx: -10, vy: 0, vx: 0, drag: false, lx: 0, ly: 0, idleAt: 0, target: null, live: false, raf: 0 };

  function norm(a) { a = a % 360; return a > 180 ? a - 360 : a < -180 ? a + 360 : a; }
  function shade() {
    for (var key in faces) {
      var a = (S.ry + faces[key]) * Math.PI / 180, lit = Math.cos(a + 0.45);   // light from the front-left
      var v = (0.5 - Math.max(0, lit) * 0.5).toFixed(3);
      shadeEls[key].forEach(function (el) { if (el) el.style.setProperty("--sh", v); });
    }
  }
  function apply() {
    obj.style.setProperty("--ry", S.ry.toFixed(2) + "deg");
    obj.style.setProperty("--rx", S.rx.toFixed(2) + "deg");
    shade();
  }
  function press(view) { btns.forEach(function (b) { b.setAttribute("aria-pressed", b.getAttribute("data-view") === view ? "true" : "false"); }); }
  function nearestView() {
    if (S.rx < -40) return "top";
    var a = norm(S.ry), best = "0", d = 999;
    [["0", 0], ["-90", -90], ["180", 180], ["-180", -180], ["90", -90]].forEach(function (p) { var dd = Math.abs(norm(a - p[1])); if (dd < d) { d = dd; best = p[0] === "-180" ? "180" : p[0] === "90" ? "-90" : p[0]; } });
    return best;
  }

  function frame(now) {
    S.raf = 0;
    if (S.target) {                                             // gliding to a chosen view
      var t = S.target, dy = norm(t.ry - S.ry), dx = t.rx - S.rx;
      S.ry += dy * 0.12; S.rx += dx * 0.12;
      if (Math.abs(dy) < 0.15 && Math.abs(dx) < 0.15) { S.ry = t.ry; S.rx = t.rx; S.target = null; S.idleAt = now + 5000; }
    } else if (!S.drag) {
      S.vy *= 0.94; S.vx *= 0.9;
      S.ry += S.vy; S.rx = Math.max(-75, Math.min(12, S.rx + S.vx));
      if (!reduce && now > S.idleAt && Math.abs(S.vy) < 0.05) { S.ry += 0.12; if (S.rx < -12) S.rx += (-10 - S.rx) * 0.02; }
    }
    apply();
    if (S.live) S.raf = requestAnimationFrame(frame);
  }
  function start() { if (!S.raf && S.live) S.raf = requestAnimationFrame(frame); }

  /* Mouse: drag anywhere on the stage. Touch: drag on the lamp itself (the grab zone stops the page from scrolling
     there, so both directions turn the lamp, including tilting to see the top); outside it the page scrolls as usual. */
  var grab = root.querySelector("[data-kbh-grab]"), active = null;
  function down(e) {
    if (e.button !== undefined && e.button > 0) return;
    if (e.currentTarget === stage && e.pointerType !== "mouse") return;      // touches are handled by the grab zone
    active = e.currentTarget; S.drag = true; S.target = null; S.lx = e.clientX; S.ly = e.clientY; S.vy = 0; S.vx = 0;
    stage.classList.add("is-drag"); root.classList.add("is-touched");
    try { active.setPointerCapture(e.pointerId); } catch (err) {}
    if (e.pointerType !== "mouse") e.preventDefault();
  }
  function move(e) {
    if (!S.drag || e.currentTarget !== active) return;
    var dx = e.clientX - S.lx, dy = e.clientY - S.ly; S.lx = e.clientX; S.ly = e.clientY;
    S.vy = dx * 0.45; S.vx = -dy * 0.32;
    S.ry += S.vy; S.rx = Math.max(-75, Math.min(12, S.rx + S.vx));
    apply();
  }
  function end() { if (!S.drag) return; S.drag = false; active = null; stage.classList.remove("is-drag"); S.idleAt = performance.now() + 3500; press(nearestView()); }
  [stage, grab].forEach(function (el) {
    if (!el) return;
    el.addEventListener("pointerdown", down);
    el.addEventListener("pointermove", move);
    el.addEventListener("pointerup", end);
    el.addEventListener("pointercancel", end);
    el.addEventListener("lostpointercapture", end);
  });

  btns.forEach(function (b) {
    b.addEventListener("click", function () {
      var v = b.getAttribute("data-view");
      S.target = v === "top" ? { ry: S.ry - norm(S.ry) - 28, rx: -58 } : { ry: S.ry + norm(parseFloat(v) - S.ry), rx: -10 };
      S.vy = 0; S.vx = 0; root.classList.add("is-touched"); press(v); start();
    });
  });

  // load the textures only when the section is close (phones get lighter files)
  var texDone = false;
  function textures() {
    if (texDone) return; texDone = true;
    var small = window.innerWidth < 900;
    [].forEach.call(obj.querySelectorAll("[data-bg]"), function (el) {
      el.style.backgroundImage = "url(" + (small && el.getAttribute("data-bg-m") || el.getAttribute("data-bg")) + ")";
    });
  }
  if ("IntersectionObserver" in window) {
    var tio = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { textures(); tio.disconnect(); } }, { rootMargin: "1200px 0px" });
    tio.observe(stage);
  } else textures();

  apply();
  if ("IntersectionObserver" in window) {
    new IntersectionObserver(function (en) {
      S.live = en[0].isIntersecting;
      if (S.live) start(); else if (S.raf) { cancelAnimationFrame(S.raf); S.raf = 0; }
    }, { rootMargin: "100px 0px" }).observe(stage);
  } else { S.live = true; start(); }
})();
